import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  }
}));

const VeljaKosninguAlert = (props) => {
  const classes = useStyles();
  const { display } = props;
  
  // Only render the component if no kosning is active
  if (!display) return null;

  return (
    <div className={classes.root}>
      <MuiAlert variant="filled" elevation={6} severity="info">
        Athugið að nauðsynlegt er að velja kosningu hér fyrir neðan til að skrá atkvæði
      </MuiAlert>
    </div>
  );
}

export default VeljaKosninguAlert;